import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useDownloadPosStyles = makeStyles((theme: Theme) =>
    createStyles({
        btn: {
            paddingLeft: theme.spacing(0.5),
        },
        margin: {
            margin: theme.spacing(1),
        },
        table: {
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: "none",
                paddingTop: theme.spacing(0),
                paddingBottom: theme.spacing(0),
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                fontSize: "inherit",
                fontWeight: "bold",
                paddingBottom: theme.spacing(2),
            },
        },
    })
);
